
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/affiliate-marketing",
      function () {
        return require("private-next-pages/affiliate-marketing.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/affiliate-marketing"])
      });
    }
  